export const initialStepTime = { avgCycleTime: 0, stepAvgTime: {} };
